// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"settingsbuttons_button_wrapper__1S_-y"};